import { Component } from '@angular/core';
import { CourseInstanceInfoCardComponent } from '../course-instance-info-card/course-instance-info-card.component';
import { AsyncPipe } from '@angular/common';
import { CourseInstanceOverviewBaseComponent } from '../../../base/CourseInstanceOverviewBaseComponent';

@Component({
  selector: 'app-course-instances-overview',
  imports: [AsyncPipe, CourseInstanceInfoCardComponent],
  templateUrl: './course-instances-overview.component.html',
  styleUrl: './course-instances-overview.component.css',
})
export class CourseInstancesOverviewComponent extends CourseInstanceOverviewBaseComponent {}
